module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 0);
}([function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.stringToHtml = t.addContentTo = t.getInnerHtml = t.getTextContent = t.TextEditor = void 0;
  var r = a(n(1)),
      o = a(n(4));

  function a(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function i(e) {
    var t = e.id,
        n = e.toolbarStyle,
        o = e.toolItemStyle,
        a = e.showHeadings,
        i = e.showJustify,
        u = e.showUndoRedo,
        c = e.editorStyle;

    var l = function l(e) {
      document.execCommand([e], !1, "");
    };

    return r.default.createElement(r.default.Fragment, null, r.default.createElement("div", {
      className: "toolbar",
      style: n
    }, r.default.createElement("div", {
      style: {
        display: a ? "" : "none"
      }
    }, [1, 2, 3, 4, 5, 6].map(function (e) {
      return r.default.createElement("button", {
        key: e,
        className: "tool-item heading-btn",
        style: o,
        onClick: function onClick() {
          return function (e) {
            var t, n;

            if (window.getSelection) {
              if ((t = window.getSelection()).getRangeAt && t.rangeCount) {
                (n = t.getRangeAt(0)).deleteContents();
                var r = document.createElement("div");
                r.innerHTML = e;

                for (var o, a, i = document.createDocumentFragment(); o = r.firstChild;) {
                  a = i.appendChild(o);
                }

                n.insertNode(i), a && ((n = n.cloneRange()).setStartAfter(a), n.collapse(!0), t.removeAllRanges(), t.addRange(n));
              }
            } else document.selection && "Control" !== document.selection.type && document.selection.createRange().pasteHTML(e);
          }("<h" + e + ">Heading " + e + "</h" + e + ">");
        }
      }, "H", e);
    })), r.default.createElement("button", {
      className: "tool-item fas fa-bold",
      style: o,
      onClick: function onClick() {
        return l("bold");
      }
    }), r.default.createElement("button", {
      className: "tool-item fas fa-italic",
      style: o,
      onClick: function onClick() {
        return l("italic");
      }
    }), r.default.createElement("button", {
      className: "tool-item fas fa-underline",
      style: o,
      onClick: function onClick() {
        return l("underline");
      }
    }), r.default.createElement("button", {
      className: "tool-item fas fa-link",
      style: o,
      onClick: function onClick() {
        return e = prompt("Add link:"), void document.execCommand("createLink", !1, e);
        var e;
      }
    }), r.default.createElement("div", {
      style: {
        display: i ? "" : "none"
      }
    }, r.default.createElement("button", {
      className: "tool-item fas fa-align-center",
      style: o,
      onClick: function onClick() {
        return l("justifyCenter");
      }
    }), r.default.createElement("button", {
      className: "tool-item fas fa-align-left",
      style: o,
      onClick: function onClick() {
        return l("justifyLeft");
      }
    }), r.default.createElement("button", {
      className: "tool-item fas fa-align-right",
      style: o,
      onClick: function onClick() {
        return l("justifyRight");
      }
    })), r.default.createElement("div", {
      style: {
        display: u ? "" : "none"
      }
    }, r.default.createElement("button", {
      className: "tool-item fas fa-undo",
      style: o,
      onClick: function onClick() {
        return l("undo");
      }
    }), r.default.createElement("button", {
      className: "tool-item fas fa-redo",
      style: o,
      onClick: function onClick() {
        return l("redo");
      }
    }))), r.default.createElement("div", {
      className: "react-text-editor",
      id: t,
      contentEditable: !0,
      suppressContentEditableWarning: !0,
      style: c
    }, r.default.createElement("p", null, "Content")));
  }

  n(7);
  var u = {
    id: o.default.string.isRequired,
    showHeadings: o.default.bool,
    showUndoRedo: o.default.bool,
    showJustify: o.default.bool,
    toolbarStyle: o.default.object,
    toolItemStyle: o.default.object,
    editorStyle: o.default.object
  };
  i.propTypes = u, i.defaultProps = {
    id: "react-text-editor",
    showHeadings: !0,
    showUndoRedo: !0,
    showJustify: !0,
    toolbarStyle: {},
    toolItemStyle: {},
    editorStyle: {}
  };
  t.TextEditor = i, t.getTextContent = function (e) {
    return document.querySelector("#" + e).textContent;
  }, t.getInnerHtml = function (e) {
    return document.querySelector("#" + e).innerHTML;
  }, t.addContentTo = function (e, t) {
    var n = document.querySelector("#" + t);
    n.innerHTML = "", n.innerHTML += e;
  }, t.stringToHtml = function (e) {
    return new DOMParser().parseFromString(e, "text/html").body.innerHTML;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = n(2);
}, function (e, t, n) {
  "use strict";
  /** @license React v17.0.2
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var r = n(3),
      o = 60103,
      a = 60106;
  t.Fragment = 60107, t.StrictMode = 60108, t.Profiler = 60114;
  var i = 60109,
      u = 60110,
      c = 60112;
  t.Suspense = 60113;
  var l = 60115,
      s = 60116;

  if ("function" == typeof Symbol && Symbol.for) {
    var f = Symbol.for;
    o = f("react.element"), a = f("react.portal"), t.Fragment = f("react.fragment"), t.StrictMode = f("react.strict_mode"), t.Profiler = f("react.profiler"), i = f("react.provider"), u = f("react.context"), c = f("react.forward_ref"), t.Suspense = f("react.suspense"), l = f("react.memo"), s = f("react.lazy");
  }

  var d = "function" == typeof Symbol && Symbol.iterator;

  function p(e) {
    for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) {
      t += "&args[]=" + encodeURIComponent(arguments[n]);
    }

    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  var y = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  },
      m = {};

  function v(e, t, n) {
    this.props = e, this.context = t, this.refs = m, this.updater = n || y;
  }

  function h() {}

  function b(e, t, n) {
    this.props = e, this.context = t, this.refs = m, this.updater = n || y;
  }

  v.prototype.isReactComponent = {}, v.prototype.setState = function (e, t) {
    if ("object" != typeof e && "function" != typeof e && null != e) throw Error(p(85));
    this.updater.enqueueSetState(this, e, t, "setState");
  }, v.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  }, h.prototype = v.prototype;
  var g = b.prototype = new h();
  g.constructor = b, r(g, v.prototype), g.isPureReactComponent = !0;
  var _ = {
    current: null
  },
      C = Object.prototype.hasOwnProperty,
      w = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function S(e, t, n) {
    var r,
        a = {},
        i = null,
        u = null;
    if (null != t) for (r in void 0 !== t.ref && (u = t.ref), void 0 !== t.key && (i = "" + t.key), t) {
      C.call(t, r) && !w.hasOwnProperty(r) && (a[r] = t[r]);
    }
    var c = arguments.length - 2;
    if (1 === c) a.children = n;else if (1 < c) {
      for (var l = Array(c), s = 0; s < c; s++) {
        l[s] = arguments[s + 2];
      }

      a.children = l;
    }
    if (e && e.defaultProps) for (r in c = e.defaultProps) {
      void 0 === a[r] && (a[r] = c[r]);
    }
    return {
      $$typeof: o,
      type: e,
      key: i,
      ref: u,
      props: a,
      _owner: _.current
    };
  }

  function j(e) {
    return "object" == typeof e && null !== e && e.$$typeof === o;
  }

  var E = /\/+/g;

  function O(e, t) {
    return "object" == typeof e && null !== e && null != e.key ? function (e) {
      var t = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + e.replace(/[=:]/g, function (e) {
        return t[e];
      });
    }("" + e.key) : t.toString(36);
  }

  function x(e, t, n, r, i) {
    var u = typeof e;
    "undefined" !== u && "boolean" !== u || (e = null);
    var c = !1;
    if (null === e) c = !0;else switch (u) {
      case "string":
      case "number":
        c = !0;
        break;

      case "object":
        switch (e.$$typeof) {
          case o:
          case a:
            c = !0;
        }

    }
    if (c) return i = i(c = e), e = "" === r ? "." + O(c, 0) : r, Array.isArray(i) ? (n = "", null != e && (n = e.replace(E, "$&/") + "/"), x(i, t, n, "", function (e) {
      return e;
    })) : null != i && (j(i) && (i = function (e, t) {
      return {
        $$typeof: o,
        type: e.type,
        key: t,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
      };
    }(i, n + (!i.key || c && c.key === i.key ? "" : ("" + i.key).replace(E, "$&/") + "/") + e)), t.push(i)), 1;
    if (c = 0, r = "" === r ? "." : r + ":", Array.isArray(e)) for (var l = 0; l < e.length; l++) {
      var s = r + O(u = e[l], l);
      c += x(u, t, n, s, i);
    } else if ("function" == typeof (s = function (e) {
      return null === e || "object" != typeof e ? null : "function" == typeof (e = d && e[d] || e["@@iterator"]) ? e : null;
    }(e))) for (e = s.call(e), l = 0; !(u = e.next()).done;) {
      c += x(u = u.value, t, n, s = r + O(u, l++), i);
    } else if ("object" === u) throw t = "" + e, Error(p(31, "[object Object]" === t ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
    return c;
  }

  function k(e, t, n) {
    if (null == e) return e;
    var r = [],
        o = 0;
    return x(e, r, "", "", function (e) {
      return t.call(n, e, o++);
    }), r;
  }

  function R(e) {
    if (-1 === e._status) {
      var t = e._result;
      t = t(), e._status = 0, e._result = t, t.then(function (t) {
        0 === e._status && (t = t.default, e._status = 1, e._result = t);
      }, function (t) {
        0 === e._status && (e._status = 2, e._result = t);
      });
    }

    if (1 === e._status) return e._result;
    throw e._result;
  }

  var T = {
    current: null
  };

  function P() {
    var e = T.current;
    if (null === e) throw Error(p(321));
    return e;
  }

  var M = {
    ReactCurrentDispatcher: T,
    ReactCurrentBatchConfig: {
      transition: 0
    },
    ReactCurrentOwner: _,
    IsSomeRendererActing: {
      current: !1
    },
    assign: r
  };
  t.Children = {
    map: k,
    forEach: function forEach(e, t, n) {
      k(e, function () {
        t.apply(this, arguments);
      }, n);
    },
    count: function count(e) {
      var t = 0;
      return k(e, function () {
        t++;
      }), t;
    },
    toArray: function toArray(e) {
      return k(e, function (e) {
        return e;
      }) || [];
    },
    only: function only(e) {
      if (!j(e)) throw Error(p(143));
      return e;
    }
  }, t.Component = v, t.PureComponent = b, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = M, t.cloneElement = function (e, t, n) {
    if (null == e) throw Error(p(267, e));
    var a = r({}, e.props),
        i = e.key,
        u = e.ref,
        c = e._owner;

    if (null != t) {
      if (void 0 !== t.ref && (u = t.ref, c = _.current), void 0 !== t.key && (i = "" + t.key), e.type && e.type.defaultProps) var l = e.type.defaultProps;

      for (s in t) {
        C.call(t, s) && !w.hasOwnProperty(s) && (a[s] = void 0 === t[s] && void 0 !== l ? l[s] : t[s]);
      }
    }

    var s = arguments.length - 2;
    if (1 === s) a.children = n;else if (1 < s) {
      l = Array(s);

      for (var f = 0; f < s; f++) {
        l[f] = arguments[f + 2];
      }

      a.children = l;
    }
    return {
      $$typeof: o,
      type: e.type,
      key: i,
      ref: u,
      props: a,
      _owner: c
    };
  }, t.createContext = function (e, t) {
    return void 0 === t && (t = null), (e = {
      $$typeof: u,
      _calculateChangedBits: t,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }).Provider = {
      $$typeof: i,
      _context: e
    }, e.Consumer = e;
  }, t.createElement = S, t.createFactory = function (e) {
    var t = S.bind(null, e);
    return t.type = e, t;
  }, t.createRef = function () {
    return {
      current: null
    };
  }, t.forwardRef = function (e) {
    return {
      $$typeof: c,
      render: e
    };
  }, t.isValidElement = j, t.lazy = function (e) {
    return {
      $$typeof: s,
      _payload: {
        _status: -1,
        _result: e
      },
      _init: R
    };
  }, t.memo = function (e, t) {
    return {
      $$typeof: l,
      type: e,
      compare: void 0 === t ? null : t
    };
  }, t.useCallback = function (e, t) {
    return P().useCallback(e, t);
  }, t.useContext = function (e, t) {
    return P().useContext(e, t);
  }, t.useDebugValue = function () {}, t.useEffect = function (e, t) {
    return P().useEffect(e, t);
  }, t.useImperativeHandle = function (e, t, n) {
    return P().useImperativeHandle(e, t, n);
  }, t.useLayoutEffect = function (e, t) {
    return P().useLayoutEffect(e, t);
  }, t.useMemo = function (e, t) {
    return P().useMemo(e, t);
  }, t.useReducer = function (e, t, n) {
    return P().useReducer(e, t, n);
  }, t.useRef = function (e) {
    return P().useRef(e);
  }, t.useState = function (e) {
    return P().useState(e);
  }, t.version = "17.0.2";
}, function (e, t, n) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      a = Object.prototype.propertyIsEnumerable;

  function i(e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, u, c = i(e), l = 1; l < arguments.length; l++) {
      for (var s in n = Object(arguments[l])) {
        o.call(n, s) && (c[s] = n[s]);
      }

      if (r) {
        u = r(n);

        for (var f = 0; f < u.length; f++) {
          a.call(n, u[f]) && (c[u[f]] = n[u[f]]);
        }
      }
    }

    return c;
  };
}, function (e, t, n) {
  e.exports = n(5)();
}, function (e, t, n) {
  "use strict";

  var r = n(6);

  function o() {}

  function a() {}

  a.resetWarningCache = o, e.exports = function () {
    function e(e, t, n, o, a, i) {
      if (i !== r) {
        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw u.name = "Invariant Violation", u;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: a,
      resetWarningCache: o
    };
    return n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  var r = n(8),
      o = n(9);
  "string" == typeof (o = o.__esModule ? o.default : o) && (o = [[e.i, o, ""]]);
  var a = {
    insert: "head",
    singleton: !1
  };
  r(o, a);
  e.exports = o.locals || {};
}, function (e, t, n) {
  "use strict";

  var r,
      o = function o() {
    return void 0 === r && (r = Boolean(window && document && document.all && !window.atob)), r;
  },
      a = function () {
    var e = {};
    return function (t) {
      if (void 0 === e[t]) {
        var n = document.querySelector(t);
        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
          n = n.contentDocument.head;
        } catch (e) {
          n = null;
        }
        e[t] = n;
      }

      return e[t];
    };
  }(),
      i = [];

  function u(e) {
    for (var t = -1, n = 0; n < i.length; n++) {
      if (i[n].identifier === e) {
        t = n;
        break;
      }
    }

    return t;
  }

  function c(e, t) {
    for (var n = {}, r = [], o = 0; o < e.length; o++) {
      var a = e[o],
          c = t.base ? a[0] + t.base : a[0],
          l = n[c] || 0,
          s = "".concat(c, " ").concat(l);
      n[c] = l + 1;
      var f = u(s),
          d = {
        css: a[1],
        media: a[2],
        sourceMap: a[3]
      };
      -1 !== f ? (i[f].references++, i[f].updater(d)) : i.push({
        identifier: s,
        updater: v(d, t),
        references: 1
      }), r.push(s);
    }

    return r;
  }

  function l(e) {
    var t = document.createElement("style"),
        r = e.attributes || {};

    if (void 0 === r.nonce) {
      var o = n.nc;
      o && (r.nonce = o);
    }

    if (Object.keys(r).forEach(function (e) {
      t.setAttribute(e, r[e]);
    }), "function" == typeof e.insert) e.insert(t);else {
      var i = a(e.insert || "head");
      if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
      i.appendChild(t);
    }
    return t;
  }

  var s,
      f = (s = [], function (e, t) {
    return s[e] = t, s.filter(Boolean).join("\n");
  });

  function d(e, t, n, r) {
    var o = n ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
    if (e.styleSheet) e.styleSheet.cssText = f(t, o);else {
      var a = document.createTextNode(o),
          i = e.childNodes;
      i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(a, i[t]) : e.appendChild(a);
    }
  }

  function p(e, t, n) {
    var r = n.css,
        o = n.media,
        a = n.sourceMap;
    if (o ? e.setAttribute("media", o) : e.removeAttribute("media"), a && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
      for (; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      e.appendChild(document.createTextNode(r));
    }
  }

  var y = null,
      m = 0;

  function v(e, t) {
    var n, r, o;

    if (t.singleton) {
      var a = m++;
      n = y || (y = l(t)), r = d.bind(null, n, a, !1), o = d.bind(null, n, a, !0);
    } else n = l(t), r = p.bind(null, n, t), o = function o() {
      !function (e) {
        if (null === e.parentNode) return !1;
        e.parentNode.removeChild(e);
      }(n);
    };

    return r(e), function (t) {
      if (t) {
        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
        r(e = t);
      } else o();
    };
  }

  e.exports = function (e, t) {
    (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = o());
    var n = c(e = e || [], t);
    return function (e) {
      if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
        for (var r = 0; r < n.length; r++) {
          var o = u(n[r]);
          i[o].references--;
        }

        for (var a = c(e, t), l = 0; l < n.length; l++) {
          var s = u(n[l]);
          0 === i[s].references && (i[s].updater(), i.splice(s, 1));
        }

        n = a;
      }
    };
  };
}, function (e, t, n) {
  (t = n(10)(!1)).push([e.i, ".toolbar{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.tool-item{\r\n    background-color: transparent;\r\n    border: none;\r\n    border-radius: 3px;\r\n    color: #5D5F61;\r\n    cursor: pointer;\r\n    height: 40px;\r\n    outline: none;\r\n    padding: 0.6rem;\r\n    width: 40px;\r\n}\r\n.tool-item:hover{\r\n    box-shadow: none;\r\n    background-color: #bdc2c959;\r\n}\r\n\r\n.heading-btn {\r\n    font-size: 0.9rem;\r\n    font-weight: 700;\r\n}\r\n\r\n.react-text-editor{\r\n    border: 1px solid #5D5F61;\r\n    border-radius: 3px;\r\n    color: #1B1B1C;\r\n    font-size: 1.2rem;\r\n    height: 50vh;\r\n    margin: 2rem;\r\n    outline: 0px solid transparent;\r\n    padding: 1rem;\r\n    overflow-y: auto;\r\n}", ""]), e.exports = t;
}, function (e, t, n) {
  "use strict";

  e.exports = function (e) {
    var t = [];
    return t.toString = function () {
      return this.map(function (t) {
        var n = function (e, t) {
          var n = e[1] || "",
              r = e[3];
          if (!r) return n;

          if (t && "function" == typeof btoa) {
            var o = (i = r, u = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(c, " */")),
                a = r.sources.map(function (e) {
              return "/*# sourceURL=".concat(r.sourceRoot || "").concat(e, " */");
            });
            return [n].concat(a).concat([o]).join("\n");
          }

          var i, u, c;
          return [n].join("\n");
        }(t, e);

        return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
      }).join("");
    }, t.i = function (e, n, r) {
      "string" == typeof e && (e = [[null, e, ""]]);
      var o = {};
      if (r) for (var a = 0; a < this.length; a++) {
        var i = this[a][0];
        null != i && (o[i] = !0);
      }

      for (var u = 0; u < e.length; u++) {
        var c = [].concat(e[u]);
        r && o[c[0]] || (n && (c[2] ? c[2] = "".concat(n, " and ").concat(c[2]) : c[2] = n), t.push(c));
      }
    }, t;
  };
}]);